import styled from '@emotion/styled'
import * as RadixSeparator from '@radix-ui/react-separator'
import { DESIGN_TOKENS } from 'constants/color.constants'
import { SPACING } from 'constants/spacing.constants'

const StyledSeparator = styled(RadixSeparator.Root)<{
    spacing?: keyof typeof SPACING
}>`
    height: 0.1rem;
    background-color: ${DESIGN_TOKENS.border.input};

    ${(p) =>
        p.spacing &&
        `margin-top: ${SPACING[p.spacing]}; margin-bottom: ${
            SPACING[p.spacing]
        };`}
`

const Separator = ({
    fullWidth,
    spacing,
}: {
    fullWidth?: boolean
    spacing?: keyof typeof SPACING
}) => {
    return (
        <StyledSeparator
            decorative
            spacing={spacing}
            style={{
                width: fullWidth ? '100%' : 'auto',
            }}
        />
    )
}

export default Separator
